export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const GET_EXECUTION_LOG_SUCCESS = 'GET_EXECUTION_LOG_SUCCESS';
export const RUN_GLOBAL_API_LOG_DATA = 'RUN_GLOBAL_API_LOG_DATA';

export const GET_CUSTOM_TABLES = 'GET_CUSTOM_TABLES';
export const GET_CUSTOM_TABLE_BY_ID_SUCCESS = 'GET_CUSTOM_TABLE_BY_ID_SUCCESS';
export const ADD_CUSTOM_TABLE_SUCCESS = 'ADD_CUSTOM_TABLE_SUCCESS';
export const DELETE_CUSTOM_TABLE_SUCCESS = 'DELETE_CUSTOM_TABLE_SUCCESS';
export const DELETE_CUSTOM_TABLE_FAIL = 'DELETE_CUSTOM_TABLE_FAIL';
export const ACTIVATE_CUSTOM_TABLE = 'ACTIVATE_CUSTOM_TABLE';
export const EDIT_CUSTOM_TABLE_SUCCESS = 'EDIT_CUSTOM_TABLE_SUCCESS';
export const EDIT_CUSTOM_TABLE_FAIL = 'EDIT_CUSTOM_TABLE_FAIL';
export const GET_EXTEND_TABLE_FIELDS_SUCCESS = 'GET_EXTEND_TABLE_FIELDS_SUCCESS';

export const CUSTOM_TABLE_SEARCH_SUCCESS = 'CUSTOM_TABLE_SEARCH_SUCCESS';
export const CUSTOM_DATA_FORMAT_SUCCESS = 'CUSTOM_DATA_FORMAT_SUCCESS';
export const CUSTOM_DATA_UPLOAD_FAILURE = 'CUSTOM_DATA_UPLOAD_FAILURE';
export const CUSTOM_TABLE_FILTER_DATA_SUCCESS = 'CUSTOM_TABLE_FILTER_DATA_SUCCESS';
export const CUSTOM_TABLE_UPDATE_SUCCESS = 'CUSTOM_TABLE_UPDATE_SUCCESS';
export const LAYOUT_RENDER_SUCCESS = 'LAYOUT_RENDER_SUCCESS';

export const ADD_FILTER_CONFIGURATION_SUCCESS = 'ADD_FILTER_CONFIGURATION_SUCCESS';
export const GET_FILTER_CONFIGURATIONS = 'GET_FILTER_CONFIGURATIONS';
export const GET_FILTER_CONFIGURATIONS_BY_PAGE = 'GET_FILTER_CONFIGURATIONS_BY_PAGE';
export const GET_FILTER_CONFIGURATION_BY_ID_SUCCESS = 'GET_FILTER_CONFIGURATION_BY_ID_SUCCESS';
export const DELETE_FILTER_CONFIGURATION_SUCCESS = 'DELETE_FILTER_CONFIGURATION_SUCCESS';
export const DELETE_FILTER_CONFIGURATION_FAIL = 'DELETE_FILTER_CONFIGURATION_FAIL';
export const GET_EXTERNAL_DATA_MAPPING_BY_ID_SUCCESS = 'GET_EXTERNAL_DATA_MAPPING_BY_ID_SUCCESS';